import metaStoreService from "core/services/metaStoreService/meta-store-service";
import MetaObjectConverter from "core/services/metaStoreService/metaobject-converter";
import componentService from "../../../../../core/services/componentService/component-service";

export default {
    process: function(newNodeType, nodeModel, parentNode, predefinedComponentName) {
        nodeModel.metaObject.autoProperties = nodeModel.metaObject.autoProperties || {};
        let componentID = componentService.getComponentIDFromName(predefinedComponentName, newNodeType);

        if (componentID) {
            nodeModel.metaObject.autoProperties = {
                ...nodeModel.metaObject.autoProperties,
                ...componentService.getPrefillProperties(componentID)
            };
        }

        function withNamespace(name) {
            return MetaObjectConverter.getGlobalId(metaStoreService.entities.PROPERTYTEMPLATE, name);
        }

        if (nodeModel.metaObject.autoProperties.adapter) {
            nodeModel.metaObject.autoProperties.adapter.handler = withNamespace(
                nodeModel.metaObject.autoProperties.adapter.handler
            );
        }

        if (nodeModel.metaObject.autoProperties.parser) {
            nodeModel.metaObject.autoProperties.parser.handler = withNamespace(
                nodeModel.metaObject.autoProperties.parser.handler
            );
        }
    }
};
